import { publicAssetUrl } from "@/common/publicAssetUrl";

export const ERROR_PAGE_DAD_SVG = publicAssetUrl(
  "/illustrations/error-page-dad.svg",
);
export const PENCIL_SVG = publicAssetUrl("/illustrations/pencil.svg");
export const LETTER_OPENED_SVG = publicAssetUrl(
  "/illustrations/letter-opened.svg",
);
export const STEPPER_SVG = publicAssetUrl("/illustrations/stepper.svg");
export const CLIPBOARD_SVG = publicAssetUrl("/illustrations/clipboard.svg");
export const CHAT_BUBBLE_SVG = publicAssetUrl(
  "/illustrations/chat-double-bubble.svg",
);
